import APP_CONFIGURATION from "@lib/app.config";
import entityBrandingStoryblokService from "@lib/storyblok/services/financial-entity-services/entity-branding-service";
export const getTermsAndConditions = async () => {
  const termsAndConditionsUrl = await entityBrandingStoryblokService.getTermsAndConditions();
  return termsAndConditionsUrl;
};
export const getPrivacyPolicy = async () => {
  const privacyPolicyUrl = await entityBrandingStoryblokService.getPrivacyPolicy();
  return privacyPolicyUrl;
};
export async function seePrivacyPolicy() {
  try {
    var _process$env$NEXT_PUB;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    //const privacyPolicyUrl = await getPrivacyPolicy()
    const privacyPolicyUrl = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_EXPLORE_PRIVACY_POLICIES_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "";
    const anchor = document.createElement("a");
    anchor.href = privacyPolicyUrl;
    anchor.target = isSafari ? "" : "_blank";
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true
    });
    anchor.dispatchEvent(clickEvent);
  } catch (error) {
    console.error("Error opening privacy policy:", error);
  }
}
export async function seeClaimsBook() {
  try {
    var _process$env$NEXT_PUB2;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    //const privacyPolicyUrl = await getPrivacyPolicy()
    const claimsBookUrl = (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_CLAIMS_BOOK_URL) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "";
    const anchor = document.createElement("a");
    anchor.href = claimsBookUrl;
    anchor.target = isSafari ? "" : "_blank";
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true
    });
    anchor.dispatchEvent(clickEvent);
  } catch (error) {
    console.error("Error opening claims book:", error);
  }
}
export async function seeTermsAndConditions() {
  try {
    var _process$env$NEXT_PUB3;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    //  const termsAndConditionsUrl = await getTermsAndConditions()
    const termsAndConditionsUrl = (_process$env$NEXT_PUB3 = process.env.NEXT_PUBLIC_EXPLORE_TERMS_AND_CONDITIONS_URL) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : "";
    const anchor = document.createElement("a");
    anchor.href = termsAndConditionsUrl;
    anchor.target = isSafari ? "" : "_blank";
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true
    });
    anchor.dispatchEvent(clickEvent);
  } catch (error) {
    console.error("Error opening terms and conditions:", error);
  }
}
export const contactEmail = () => {
  window.location.href = "mailto:".concat(APP_CONFIGURATION.config.contactInformation.email);
};
export const contactCancelationsNumber = async () => {
  window.location.href = "tel:".concat(APP_CONFIGURATION.config.contactInformation.cancelationsPhoneNumber);
};
export const contactSupportNumber = async () => {
  window.location.href = "tel:".concat(APP_CONFIGURATION.config.contactInformation.phoneNumber);
};
export const downloadDocType = async docType => {
  try {
    const url = getDocTypeUrl(docType);
    executeIfSafari(() => window.open(url, "_blank"), () => window.open(url, "_blank"));
  } catch (error) {
    console.error("Download error:", error);
  }
};
export const getDocTypeUrl = function (docType) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "es";
  const userLocale = localStorage.getItem('locale');
  const encodedDocType = encodeURIComponent(docType);
  const encodedLang = encodeURIComponent(userLocale !== null && userLocale !== void 0 ? userLocale : locale);
  return "/api/pdf/".concat(encodedDocType, "/").concat(encodedLang);
};
export const openLink = link => {
  try {
    const url = encodeURI(link);
    executeIfSafari(() => window.location.href = url, () => window.open(url, "_blank"));
  } catch (error) {
    console.error("Download error:", error);
  }
};
const executeIfSafari = (onSafari, onNotSafari) => {
  const isSafari = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
  if (isSafari) {
    onSafari();
  } else {
    onNotSafari();
  }
};